// import { X } from 'lucide-react';
import bookicon from '@/assets/bookicon.svg';
import treasure from '@/assets/treasure.svg';
import { Button } from '../ui/button';
import clues from '@/assets/clues.svg';
import { useModal } from '@/hooks/useModal';
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import arrowLottie from "@/assets/lottie/arrow.lottie?url";


// function CloseButton() {
//     const { closeModal } = useModal();

//     return (
//         // biome-ignore lint/a11y/useButtonType: <explanation>
//         <button className="bg-blue-sky opacity-50 text-gray-400 hover:text-gray-600 p-2 rounded-tl-xl rounded-br-xl top-0 left-0 absolute z-50"
//         onClick={() => {
//             console.log('Close button clicked');
//             closeModal()
//         }}>
//             <X size={28} />
//         </button>
//     );
// }

function Header() {
  return (
    <div className="flex flex-col items-center mb-4 pt-6">
        <div className="text-white">
          <img
            src={bookicon}
            className='h-16'
            alt='book'
          />
        </div>
      <h2 className="text-2xl font-semibold text-blue-dark mt-4">Scratching Smart</h2>
    </div>
  );
}

interface InfoSectionProps {
    // Accept any React node as the icon
    icon: React.ReactNode;
    title: string;
    subtitle: string;
    // Optional className for styling the wrapper
    className?: string;
}
  
  function InfoSection({
    icon,
    title,
    subtitle,
    className = "mt-4 flex items-start gap-4 px-5",
  }: InfoSectionProps) {
    return (
      <div className={className}>
        {/* Just render whatever icon element is passed in */}
        {icon}
        
        <div>
          <div className="-translate-y-1">
            <h3 className="text-2xl font-semibold text-blue-dark">{title}</h3>
            <p className="text-blue-dark text-lg text-left">{subtitle}</p>
          </div>
        </div>
      </div>
    );
  }
  
  // Example custom icon components
  function TreasureIcon() {
    return (
      <img src={treasure} className="w-9 h-9" alt="Treasure" />
    );
  }
  
  function CluesIcon() {
    return (
      <img src={clues} className="w-9 -translate-y-1" alt="Clues" />
    );
  }
  
  function CustomDollarIcon() {
    return (
    <div className="relative h-9 flex items-center translate-y-[1px]">
        <div className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center">
          <span className="text-blue-500 font-bold">$</span>
        </div>
        <div className="absolute inset-0 border-2 border-blue-400 border-dashed rounded-full animate-spin" style={{ animationDuration: '10s' }} />
      </div>
    );
  }
  
  // Now using the separate icon components
  function HowToWinSection() {
    return (
      <InfoSection
        icon={<TreasureIcon />}
        title="How to win"
        subtitle="Find 6 or more treasures to win. Find up to 10 to win big"
      />
    );
  }
  
  function SolveWithCluesSection() {
    return (
      <InfoSection
        icon={<CluesIcon />}
        title="Solve with clues"
        subtitle="The numbers reveal how far away the nearest treasure is, by the number of edges."
      />
    );
  }
  
  function GoFastSection() {
    return (
      <InfoSection
        icon={<CustomDollarIcon />}
        title="Go fast to win big"
        subtitle="To win the largest prizes, find 10 treasures fastest"
      />
    );
  }

// Start Button Component
function StartButton() {
  const { closeModal } = useModal();

  const onClickHandler = () => {
    closeModal();
  };

  return (
    <div className="mt-2 p-4 flex justify-center">
        <Button 
          className="py-6 bg-blue text-white text-2xl font-bold w-full rounded-lg flex items-center justify-center gap-3"
          shine
          onClick={() => onClickHandler()}
        >
            <span className='items-center justify-center'>Start Playing</span>
            <span className='h-5 w-5 flex items-center justify-center'>
              <DotLottieReact
                src={arrowLottie}
                autoplay
                loop
                style={{
                  objectFit: "contain",
                  transform: "translateY(2px)"
                }}
              />
            </span>
        </Button>
    </div>
  );
}

// Main TutorialModal Component
export function TutorialModal() {
  return (
    <div className="bg-white rounded-xl min-w-md mx-4 w-80 relative">
      <div>
        <div className="relative">
          <Header />
        </div>
        <div className="mt-6">
            <HowToWinSection />
            <SolveWithCluesSection />
            <GoFastSection />
        </div>
      </div>
      <StartButton />
    </div>
  );
}